export default __webpack_public_path__ + "static/media/bg.b969cf34.png";